exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".root_tree {\n  width: 100%;\n  height: 100%;\n  border: solid 0px #ccc;\n  border-radius: 5px;\n  overflow-y: auto; }\n\n.main-container {\n  overflow: auto;\n  height: 100%;\n  width: 100%; }\n\n.node-container {\n  height: 100%; }\n  .node-container .list-container:first-child {\n    margin-top: 10px; }\n\n.list-container {\n  min-height: 38px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding-left: 10px;\n  cursor: pointer; }\n\n.selected {\n  background-color: #007BB9;\n  color: #fff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/select-list/select-list.component.scss
// module id = ../../../../../src/app/core/components/select-list/select-list.component.scss
// module chunks = main